import React from 'react';
import { useDispatch } from 'react-redux';
import { apiAction } from '../../../store/generalSlice';

const BidConstraints = (props) => {
  const dispatch = useDispatch();
  const { action, fieldName, field, objectField, state, setState, adsetTargetingFields } = props;

  const updateValue = (e, fieldName) => {
    setState((prevState) => {
      if (typeof prevState[field.id].value !== 'object') {
        return {
          ...prevState,
          [field.id]: {
            ...prevState[field.id],
            value: { [fieldName]: e.target.value },
          },
        };
      }
      return {
        ...prevState,
        [field.id]: {
          ...prevState[field.id],
          value: { ...prevState[field.id].value, [fieldName]: e.target.value },
        },
      };
    });
  };

  const SaveButton = () => {
    return (
      <>
        <button
          className='btn btn-sm btn-success mt-2'
          onClick={() => {
            dispatch(
              apiAction({
                reduxField: 'action',
                route: `actions/updateDuplicateAction`,
                actionId: action._id,
                fieldName,
                changes: { ...state },
              })
            );
          }}
        >
          Save
        </button>
      </>
    );
  };

  return (
    <div key={field.id} className='col-md-6 p-3 border'>
      <label>
        <b>Bid Constraints: </b>
        Constraints on the bid amount - ONLY WHEN BID_STRATEGY IS ROAS
      </label>
      <div>
        <label>roas_average_floor</label>
        <input
          type='number'
          className='form-control'
          defaultValue={
            typeof state[field.id]?.value === 'object' ? state[field.id].value.roas_average_floor : undefined
          }
          disabled={state[field.id] ? state[field.id].isUseSource : null}
          onChange={(e) => updateValue(e, 'roas_average_floor')}
        />
        {state[field.id]?.value?.roas_average_floor !== action[fieldName][field.id]?.value?.roas_average_floor ? (
          <SaveButton />
        ) : null}
      </div>
      <div>
        <div className='form-check mt-2'>
          <input
            type='checkbox'
            className='form-check-input'
            checked={state[field.id] ? state[field.id].isUseSource : null}
            onChange={(e) => {
              setState((prevState) => {
                return {
                  ...prevState,
                  [field.id]: { ...prevState[field.id], isUseSource: e.target.checked },
                };
              });
              dispatch(
                apiAction({
                  reduxField: 'action',
                  route: `actions/updateDuplicateAction`,
                  actionId: action._id,
                  fieldName,
                  changes: { ...state, [field.id]: { ...state[field.id], isUseSource: e.target.checked } },
                })
              );
            }}
          />
          <label className='form-check-label'>Use Source</label>
        </div>
      </div>
    </div>
  );
};

export default BidConstraints;
